import type { BookingReservationPartyLookup } from '../Types/bookingReservationTable.types';
import { mapReservationPartyToBookingReservationPartyLookup } from './bookingReservationPartiesLookupMapper';

type BookingReservationPartyLookupSource =
  Parameters<typeof mapReservationPartyToBookingReservationPartyLookup>[0];

export const mapBookingReservationPartiesLookup = (
  parties: BookingReservationPartyLookupSource[] | undefined
): BookingReservationPartyLookup[] =>
  (parties ?? [])
    .map((party) => mapReservationPartyToBookingReservationPartyLookup(party))
    .filter((item): item is BookingReservationPartyLookup => item !== undefined);
